import * as React from 'react';
import { useContext } from 'react';
import { MRT_ColumnDef, MRT_DensityState, MRT_VisibilityState } from 'material-react-table';
import {
    defaultDisputesColumns,
    defaultDisputesPanelColumns,
    defaultDisputesColumnSizing,
    IDisputeItem,
    defaultDisputesPanelColumnSizing
} from './disputes/disputes-data';
import { IOrdersRowData } from '../../interfaces/orders';
import { defaultOrdersColumns, defaultOrdersColumnSizing, OrdersTableAccessorKeys } from './order/order-data';
import { defaultMerchantsColumns, defaultMerchantsColumnSizing } from './account/merchant-data';
import {
    ApplicationTableAccessorKey,
    defaultApplicationColumnSizing,
    defaultApplicationsColumns,
} from './account/applications-data';
import { defaultPartnerColumns, defaultPartnerColumnSizing } from './partners/partners-data';
import { CLAIMS } from '../../utils/roles-helper';
import {
    defaultDisputeTransactionsColumns,
    defaultTransactionColumnSizing,
    defaultTransactionsColumns
} from './admin/transactions-data';
import {
    defaultSettlementsColumns,
    defaultSettlementsColumnSizing,
    SettlementsTableAccessorKeys
} from './funds/settlements-data';
import { defaultSettlementDetailsColumns, defaultSettlementDetailsColumnSizing } from './funds/settlement-details-data';
import {
    defaultUnpostedBatchesColumns,
    defaultUnpostedBatchesColumnSizing, UnpostedBatchesTableAccessorKeys,
} from './funds/unposted-batches';
import { defaultBatchesColumnSizing, defaultBatchesColumns, BatchesTableAccessorKeys } from './funds/batches-data';
import { defaultPayoutDetailsColumns, defaultPayoutDetailsColumnSizing } from './funds/payout-details-data';
import {
    defaultWebhookActivityColumns,
    defaultWebhookActivityColumnSizing,
    WebhookActivityTableAccessorKeys
} from './developers/webhook-activity-data';
import { defaultBlockListColumns } from './fraud-and-risk/block-list-data';
import { defaultUsersColumns, defaultUsersColumnSizing } from './user/users-data';
import { defaultActivityLogColumns, defaultActivityLogColumnSizing } from './admin/activity-log-data';
import { defaultProviderColumns, defaultProviderColumnSizing } from './admin/provider-data';
import {
    defaultDisputesArchivedColumns, defaultDisputesQueueColumnSizing,
    defaultDisputesQueueItemsColumns,
    defaultDisputesQueueItemsColumnSizing, defaultDisputesQueuesColumns, DisputesQueueTableAccessorKey,
} from './disputes/disputes-queue';
import { defaultAccountColumns, defaultAccountColumnSizing } from './account/account-data';
import { defaultAccountMerchantsColumns, defaultAccountMerchantsColumnSizing } from './account/account-merchant-data';
import { defaultAccountApplicationColumns, defaultAccountApplicationColumnSizing } from './account/account-application-data';
import { defaultContactsColumns, defaultContactsColumnSizing } from './contacts/contacts-data';
import { defaultApiClientsColumns, defaultApiClientsColumnSizing } from './admin/api-client-data';
import { defaultContactOrdersColumns, defaultContactOrdersColumnSizing } from './contacts/contact-order-data';
import { defaultOwnerColumns, defaultOwnerColumnSizing } from './account/owner-data';
import { defaultAuditLogsColumns, defaultAuditLogsColumnSizing } from './admin/audit-logs-data';
import { defaultAuditLogsDetailsColumns, defaultAuditLogsDetailsColumnSizing } from './admin/audit-logs-details-data';
import {
    defaultFundReserveConfigColumns,
    defaultFundReserveConfigColumnSizing,
    defaultFundReserveConfigInactiveColumns, defaultFundReserveConfigInactiveColumnSizing,
} from './fraud-and-risk/fund-reserve-config-data';
import { defaultReserveFundColumns, defaultReserveFundColumnSizing } from './funds/reserve-fund-data';
import { defaultReserveFundDetailsColumns, defaultReserveFundDetailsColumnSizing } from './funds/reserv-fund-details-data';
import { defaultPartnersCommissionsColumns, defaultPartnersCommissionsColumnSizing } from './sales-agencies/partners-commissions-data';
import { defaultPartnersDealsColumns, defaultPartnersDealsColumnSizing } from './partners/partners-deals-data';
import {
    defaultPartnersDealsDetailsColumns,
    defaultPartnersDealsDetailsColumnSizing,
} from './partners/partners-deals-details-data';
import {
    defaultPartnersCommissionsDetailsColumns,
    defaultPartnersCommissionsDetailsColumnSizing,
} from './sales-agencies/partners-commissions-details-data';
import { defaultMainCommissionsColumns, defaultMainCommissionsColumnSizing } from './sales-agencies/main-commission-data';
import { defaultPartnerFeesColumns, defaultPartnerFeesColumnSizing } from './partners/partner-fees-data';
import { defaultFinancialAccountColumns, defaultFinancialAccountColumnSizing } from './funds/financial-account-data';
import { defaultDocumentsColumns, defaultDocumentsColumnSizing } from './account/documents-data';
import {
    defaultDisputesAlertProvidersColumns,
    defaultDisputesAlertProvidersColumnSizing,
    DisputesAlertProvidersTableAccessorKeys,
} from './admin/alert-providers-data';
import { defaultSalesAgenciesColumns, defaultSalesAgenciesColumnSizing } from './sales-agency/sales-agencies-data';
import {
    defaultQuarantinedProviderColumns,
    defaultQuarantinedProviderColumnSizing,
} from './admin/quarantined-providers-data';
// import { defaultDisputeDetailsColumns, defaultDisputeDetailsColumnSizing } from './dispute-details-data';

enum tablesActionTypes {
    SET_TABLE_DATA = 'SET_TABLE_DATA',
    SET_TABLE_COLUMN_SIZE = 'SET_TABLE_COLUMN_SIZE',
    SET_TABLE_DENSITY = 'SET_TABLE_DENSITY',
    SET_TABLE_VISIBILITY_STATE = 'SET_TABLE_VISIBILITY_STATE',
}

export enum TablesNames {
    disputesTableData = 'disputesTableData',
    disputesTablePanelData = 'disputesTablePanelData',
    disputesQueueItemsTableData = 'disputesQueueItemsTableData',
    disputesQueueTableData = 'disputesQueueTableData',
    disputesArchivedTableData = 'disputesArchivedTableData',
    orderTableData = 'orderTableData',
    merchantTableData = 'merchantTableData',
    applicationsTableData = 'applicationsTableData',
    partnerTableData = 'partnerTableData',
    accountTableData = 'accountTableData',
    transactionTableData = 'transactionTableData',
    settlementsTableData = 'settlementsTableData',
    settlementDetailsTableData = 'settlementDetailsTableData',
    unpostedBatchesTableData = 'unpostedBatchesTableData',
    batchesTableData = 'batchesTableData',
    payoutDetailsTableData = 'payoutDetailsTableData',
    webhookActivityTableData = 'webhookActivityTableData',
    blockListTableData = 'blockListTableData',
    userListTableData = 'userListTableData',
    activityLogTableData = 'activityLogTableData',
    providerTableData = 'providerTableData',
    quarantinedProvidersTableData = 'quarantinedProvidersTableData',
    disputesAlertProvidersTableData = 'disputesAlertProvidersTableData',
    disputesTransactionTableData = 'disputesTransactionTableData',
    accountMerchantTableData = 'accountMerchantTableData',
    accountApplicationTableData = 'accountApplicationTableData',
    contactsTableData = 'contactsTableData',
    apiClientTableData = 'apiClientTableData',
    contactOrderTableData = 'contactOrderTableData',
    merchantOwnerTableData = 'merchantOwnerTableData',
    auditLogsTableData = 'auditLogsTableData',
    auditLogsDetailPanelTableData = 'auditLogsDetailPanelTableData',
    fundsReserveConfigActive = 'fundsReserveConfigActive',
    fundsReserveConfigInactive = 'fundsReserveConfigInactive',
    reserveFundTableData = 'reserveFundTableData',
    reserveFundDetailsTableData = 'reserveFundDetailsTableData',
    partnersCommissionsTableData = 'partnersCommissionsTableData',
    partnersCommissionsDetailsTableData = 'partnersCommissionsDetailsTableData',
    partnersDealsTableData = 'partnersDealsTableData',
    partnersDealsDetailsTableData = 'partnersDealsDetailsTableData',
    mainCommissionsTableData = 'mainCommissionsTableData',
    partnerFeesTableData = 'partnerFeesTableData',
    financialAccountTableData = 'financialAccountTableData',
    documentsTableData = 'documentsTableData',
    salesAgenciesTableData = 'salesAgenciesTableData',

}

interface IAction {
    type: tablesActionTypes;
    // data: MRT_ColumnDef<IDisputeItem>[] | MRT_ColumnDef<IOrdersRowData>[];
    data: any;
    name: TablesNames;
    size: ColumnSizing;
    density: MRT_DensityState;
    visibilityState: MRT_VisibilityState;
}

export type TablesData = MRT_ColumnDef<IDisputeItem>[] | MRT_ColumnDef<IOrdersRowData>[]
export type ColumnSizing = Record<string, number>

interface ITableData {
    // data: TablesData;
    data: any;
    columnSizing: ColumnSizing;
    density: MRT_DensityState;
    visibilityState: MRT_VisibilityState;
    showsFor?: {
        [key: string]: CLAIMS,
    };
}

interface IState {
    disputesTableData: ITableData;
    disputesTablePanelData: ITableData;
    orderTableData: ITableData;
}

type tablesProviderProps = { children: React.ReactElement }

const tablesStateContext = React.createContext<{ tablesContextState: IState; dispatch: React.Dispatch<IAction> } | undefined>(undefined);

const tablesReducer = (state: IState, action: IAction): IState => {
    switch (action.type) {
        case tablesActionTypes.SET_TABLE_DATA: {
            return { ...state, [state[action.name as string]]: { ...state[action.name], data: action.data as MRT_ColumnDef<IDisputeItem>[] }};
        }
        case tablesActionTypes.SET_TABLE_COLUMN_SIZE: {
            return { ...state, [action.name as string]: { ...state[action.name], columnSizing: { ...action.size }}};
        }
        case tablesActionTypes.SET_TABLE_DENSITY: {
            return { ...state, [action.name as string]: { ...state[action.name], density: action.density }};
        }
        case tablesActionTypes.SET_TABLE_VISIBILITY_STATE: {
            return { ...state, [action.name as string]: { ...state[action.name], visibilityState: action.visibilityState }};
        }
        default: {
            return state;
        }
    }
};

const initialState = {
    disputesTableData: {
        data: defaultDisputesColumns,
        columnSizing: defaultDisputesColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    disputesTablePanelData: {
        data: defaultDisputesPanelColumns,
        columnSizing: defaultDisputesPanelColumnSizing,
        density: 'compact' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    disputesQueueItemsTableData: {
        data: defaultDisputesQueueItemsColumns,
        columnSizing: defaultDisputesQueueItemsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    disputesQueueTableData: {
        data: defaultDisputesQueuesColumns,
        columnSizing: defaultDisputesQueueColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [DisputesQueueTableAccessorKey.partnerId]: CLAIMS.SUPER_ADMIN
        }
    },
    disputesArchivedTableData: {
        data: defaultDisputesArchivedColumns,
        columnSizing: defaultDisputesQueueItemsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    orderTableData: {
        data: defaultOrdersColumns,
        columnSizing: defaultOrdersColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [OrdersTableAccessorKeys.merchantName]: CLAIMS.SUPER_ADMIN
        }
    },
    merchantTableData: {
        data: defaultMerchantsColumns,
        columnSizing: defaultMerchantsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    applicationsTableData: {
        data: defaultApplicationsColumns,
        columnSizing: defaultApplicationColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [ApplicationTableAccessorKey.partnerId]: CLAIMS.SUPER_ADMIN
        }
    },
    partnerTableData: {
        data: defaultPartnerColumns,
        columnSizing: defaultPartnerColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    accountTableData: {
        data: defaultAccountColumns,
        columnSizing: defaultAccountColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    transactionTableData: {
        data: defaultTransactionsColumns,
        columnSizing: defaultTransactionColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    disputesTransactionTableData: {
        data: defaultDisputeTransactionsColumns,
        columnSizing: defaultTransactionColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    settlementsTableData: {
        data: defaultSettlementsColumns,
        columnSizing: defaultSettlementsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [SettlementsTableAccessorKeys.sender]: CLAIMS.SUPER_ADMIN,
            [SettlementsTableAccessorKeys.receiver]: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN
        }
    },
    settlementDetailsTableData: {
        data: defaultSettlementDetailsColumns,
        columnSizing: defaultSettlementDetailsColumnSizing,
        density: 'compact' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    unpostedBatchesTableData: {
        data: defaultUnpostedBatchesColumns,
        columnSizing: defaultUnpostedBatchesColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [UnpostedBatchesTableAccessorKeys.sender]: CLAIMS.SUPER_ADMIN,
        }
    },
    batchesTableData: {
        data: defaultBatchesColumns,
        columnSizing: defaultBatchesColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [BatchesTableAccessorKeys.sender]: CLAIMS.SUPER_ADMIN,
        }
    },
    payoutDetailsTableData: {
        data: defaultPayoutDetailsColumns,
        columnSizing: defaultPayoutDetailsColumnSizing,
        density: 'compact' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    webhookActivityTableData: {
        data: defaultWebhookActivityColumns,
        columnSizing: defaultWebhookActivityColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [WebhookActivityTableAccessorKeys.mid]: CLAIMS.SUPER_ADMIN
        }
    },
    blockListTableData: {
        data: defaultBlockListColumns,
        columnSizing: {},
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    userListTableData: {
        data: defaultUsersColumns,
        columnSizing: defaultUsersColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    activityLogTableData: {
        data: defaultActivityLogColumns,
        columnSizing: defaultActivityLogColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    providerTableData: {
        data: defaultProviderColumns,
        columnSizing: defaultProviderColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    quarantinedProvidersTableData: {
        data: defaultQuarantinedProviderColumns,
        columnSizing: defaultQuarantinedProviderColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    disputesAlertProvidersTableData: {
        data: defaultDisputesAlertProvidersColumns,
        columnSizing: defaultDisputesAlertProvidersColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        showsFor: {
            [DisputesAlertProvidersTableAccessorKeys.partnerId]: CLAIMS.SUPER_ADMIN
        }
    },
    accountMerchantTableData: {
        data: defaultAccountMerchantsColumns,
        columnSizing: defaultAccountMerchantsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    accountApplicationTableData: {
        data: defaultAccountApplicationColumns,
        columnSizing: defaultAccountApplicationColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    contactsTableData: {
        data: defaultContactsColumns,
        columnSizing: defaultContactsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    apiClientTableData: {
        data: defaultApiClientsColumns,
        columnSizing: defaultApiClientsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    contactOrderTableData: {
        data: defaultContactOrdersColumns,
        columnSizing: defaultContactOrdersColumnSizing,
        density: 'compact' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    merchantOwnerTableData: {
        data: defaultOwnerColumns,
        columnSizing: defaultOwnerColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    auditLogsTableData: {
        data: defaultAuditLogsColumns,
        columnSizing: defaultAuditLogsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    auditLogsDetailPanelTableData: {
        data: defaultAuditLogsDetailsColumns,
        columnSizing: defaultAuditLogsDetailsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    partnersCommissionsTableData: {
        data: defaultPartnersCommissionsColumns,
        columnSizing: defaultPartnersCommissionsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    partnersCommissionsDetailsTableData: {
        data: defaultPartnersCommissionsDetailsColumns,
        columnSizing: defaultPartnersCommissionsDetailsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    partnersDealsTableData: {
        data: defaultPartnersDealsColumns,
        columnSizing: defaultPartnersDealsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    partnersDealsDetailsTableData: {
        data: defaultPartnersDealsDetailsColumns,
        columnSizing: defaultPartnersDealsDetailsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    mainCommissionsTableData: {
        data: defaultMainCommissionsColumns,
        columnSizing: defaultMainCommissionsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    partnerFeesTableData: {
        data: defaultPartnerFeesColumns,
        columnSizing: defaultPartnerFeesColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
        enableDensityToggle: false
    },
    fundsReserveConfigActive: {
        data: defaultFundReserveConfigColumns,
        columnSizing: defaultFundReserveConfigColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    fundsReserveConfigInactive: {
        data: defaultFundReserveConfigInactiveColumns,
        columnSizing: defaultFundReserveConfigInactiveColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    reserveFundTableData: {
        data: defaultReserveFundColumns,
        columnSizing: defaultReserveFundColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    reserveFundDetailsTableData: {
        data: defaultReserveFundDetailsColumns,
        columnSizing: defaultReserveFundDetailsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    financialAccountTableData: {
        data: defaultFinancialAccountColumns,
        columnSizing: defaultFinancialAccountColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    documentsTableData: {
        data: defaultDocumentsColumns,
        columnSizing: defaultDocumentsColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
    salesAgenciesTableData: {
        data: defaultSalesAgenciesColumns,
        columnSizing: defaultSalesAgenciesColumnSizing,
        density: 'comfortable' as MRT_DensityState,
        visibilityState: {} as MRT_VisibilityState,
    },
};

const TablesProvider = ({ children }: tablesProviderProps): JSX.Element => {
    const [tablesContextState, dispatch] = React.useReducer(tablesReducer, initialState);
    const value = { tablesContextState, dispatch };
    return (
        <tablesStateContext.Provider value={value}>
            {children}
        </tablesStateContext.Provider>
    );
};

const useTablesContext = (): { tablesContextState: IState; dispatch: React.Dispatch<IAction> } => {
    const context = useContext(tablesStateContext);
    if (context === undefined) {
        throw new Error('useDisputesContext must be used within a DisputesProvider');
    }
    return context;
};

export const setResize = (dispatch, name: TablesNames, value: ColumnSizing): void => {
    dispatch({ type: tablesActionTypes.SET_TABLE_COLUMN_SIZE, name, size: value });
};

export const setDensity = (dispatch, name: TablesNames, value: MRT_DensityState): void => {
    if (value) {
        dispatch({ type: tablesActionTypes.SET_TABLE_DENSITY, name, density: value });
    }
};

export const setVisibilityState = (dispatch, name: TablesNames, value: MRT_VisibilityState): void => {
    if (value) {
        dispatch({ type: tablesActionTypes.SET_TABLE_VISIBILITY_STATE, name, visibilityState: value });
    }
};

export { TablesProvider, useTablesContext };
